import { GradeMarkApi } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    gradeMarks: [],
    gradeMark: {},
  },
  actions: {
    async fetchAll({ commit }, params) {
      const data = await GradeMarkApi.fetch(params)
      commit('setGradeMarks', data)
    },
    createMany(_, body) {
      return GradeMarkApi.createMany(body)
    },
    async fetchOne({ commit }, id) {
      const data = await GradeMarkApi.fetchOne(id)
      commit('setGradeMark', data)
    },
    update(_, { id, ...body }) {
      return GradeMarkApi.update(id, body)
    },
    delete(_, id) {
      return GradeMarkApi.remove(id)
    },
    deParent(_, params) {
      return GradeMarkApi.deParent(params)
    },
  },
  mutations: {
    setGradeMarks(state, data) {
      state.gradeMarks = data
    },
    setGradeMark(state, data) {
      state.gradeMark = data
    },
  },
  getters: {
    getGradeMarks(state) {
      return state.gradeMarks
    },
    getGradeMark(state) {
      return state.gradeMark
    },
    getDisplayedMarks: (state) => {
      const marks = state.gradeMarks
      let groups = marks.filter((x) => x.isGroup)
      const nonGroups = marks.filter((x) => !x.isGroup && !x.parent)
      if (Array.isArray(groups) && groups.length) {
        groups = groups.map((g) => ({ ...g, children: marks.filter((m) => m.parent === g.id) }))
      }
      return [...groups, ...nonGroups].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    },
  },
}
